import { apiSlice } from '../../app/api/apiSlice'
import { urlConfig } from '../../config'

const coinSlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    getCoins: build.query<any, void>({
      query: () => `${urlConfig.tradesBaseUrl}/trades/coins`,
    }),
    getCurrencies: build.query<any, void>({
      query: () => `${urlConfig.tradesBaseUrl}/trades/coins/currency`,
    }),
  }),
})

export const { useGetCoinsQuery, useGetCurrenciesQuery } = coinSlice
